import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import api from '@/lib/api';

export async function initPushNotifications() {
    debugger
  if (Capacitor.getPlatform() !== 'android') return;

  let perm = await PushNotifications.checkPermissions();

  if (perm.receive !== 'granted') {
    perm = await PushNotifications.requestPermissions();
  }

  if (perm.receive !== 'granted') return;

  await PushNotifications.register();

  PushNotifications.addListener('registration', async (token) => {
    await api.post('/users/push-token', {
      token: token.value,
      platform: 'android',
    });
  });

  PushNotifications.addListener('pushNotificationActionPerformed', (event) => {
    const data = event.notification.data;

    if (data?.projectId && data?.eventId) {
      window.location.href = `/projects/${data.projectId}/${data.eventId}`;
    }

    if (data?.projectId && !data?.eventId) {
      window.location.href = `/projects/${data.projectId}`;
    }

  });
}